import { render } from "./HeroiconsSolidDocumentRemove.vue?vue&type=template&id=0a57cd7e"
const script = {}

import exportComponent from "/Users/dorinpuscasu/Desktop/Projects/linella/linella-backend/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidDocumentRemove.vue"]])

export default __exports__